import { Map } from "immutable";
import Widget, { widgetAttributesForComparison } from "views/logic/widgets/Widget";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import EventsWidgetConfig from "./EventsWidgetConfig";
const _EventsWidget = class _EventsWidget extends Widget {
  constructor(id, config, filter, timerange, query, streams, streamCategories, filters, description, context) {
    super(
      id,
      _EventsWidget.type,
      config,
      filter,
      timerange,
      query,
      streams,
      streamCategories,
      filters,
      description,
      context
    );
  }
  static fromJSON(value) {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = value;
    return new _EventsWidget(
      id,
      EventsWidgetConfig.fromJSON(config),
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
  equals(other) {
    if (other instanceof _EventsWidget) {
      return widgetAttributesForComparison.every((key) => isDeepEqual(this[key], other[key]));
    }
    return false;
  }
  equalsForSearch(other) {
    if (other instanceof _EventsWidget) {
      return widgetAttributesForComparison.every((key) => isEqualForSearch(this[key], other[key]));
    }
    return false;
  }
  toBuilder() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this._value;
    return new Builder(
      Map({ id, config, filter, timerange, query, streams, stream_categories, filters, description, context })
    );
  }
  static builder() {
    return new Builder();
  }
};
_EventsWidget.type = "events";
_EventsWidget.defaultTitle = "Untitled Events Overview";
let EventsWidget = _EventsWidget;
export {
  EventsWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this.value.toObject();
    return new EventsWidget(
      id,
      config,
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
}
